import React from 'react';
import { costRows } from '../data/comparisons';
export function CostOfInaction() {
  return <section aria-labelledby="cost-heading" className="w-full bg-cream" data-id="element-84" data-mp="2py7qj4m0igf9">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-85" data-mp="2q0kdxxajhizp">
        <h2 id="cost-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-86" data-mp="2uwiyf9sqyguu">
          What does starting over actually cost you?
        </h2>

        <div className="mt-10 overflow-hidden rounded-2xl bg-white border border-cream-dark" data-id="element-87" data-mp="34vrqty7yrnf3">
          <div className="grid grid-cols-2" data-id="element-88" data-mp="38vsf0akv7czc">
            <p className="px-5 py-3 bg-cream-dark text-xs font-bold uppercase tracking-[0.12em] text-ink-soft" data-id="element-89" data-mp="3dollp3zw8ve2">
              Without a system built for real weeks
            </p>
            <p className="px-5 py-3 bg-cream-dark text-xs font-bold uppercase tracking-[0.12em] text-danger border-l border-white" data-id="element-90" data-mp="3ip9bxngat878">
              The real cost
            </p>
          </div>

          {costRows.map(row => <div key={row.before} className="grid grid-cols-2 border-t border-cream-dark" data-id="element-91" data-mp="3egzkn42uvey3">
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-ink-soft" data-id="element-92" data-mp="39fsa4x9bw1nq">
                {row.before}
              </p>
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-ink font-medium border-l border-cream-dark" data-id="element-93" data-mp="30gos7wlwdsat">
                {row.after}
              </p>
            </div>)}
        </div>

        <p className="mt-10 font-serif italic text-lg sm:text-xl text-ink text-center max-w-2xl mx-auto leading-relaxed" data-id="element-94" data-mp="3s7cs75bu4rmw">
          This costs about what the last planner you abandoned cost. The
          difference is what happens in week three.
        </p>
        <p className="mt-4 font-semibold text-sage text-center" data-id="element-95" data-mp="3jdge8dstqlik">
          Your next derailed week can end completely differently.
        </p>
      </div>
    </section>;
}